// extracted by mini-css-extract-plugin
module.exports = {"header-editor-base__zoom-info":"HeaderEditorBase_header-editor-base__zoom-info__9lh9K"};